import { Theme, Components } from '@mui/material/styles';

export const IconButtonOverrides: Components<Theme> = {
  MuiIconButton: {
    styleOverrides: {
      root: () => ({
        // boxShadow: 'none',
        // borderRadius: (theme.vars || theme).shape.borderRadius,
        // textTransform: 'none',
        // fontWeight: theme.typography.fontWeightMedium,
        // letterSpacing: 0,
        color: '#FFFFFF',
        backgroundColor: '#0F60FF',
        transition: 'all, 350ms ease-in-out',
        // border: '1px solid ',
        // borderColor: gray[200],
        // backgroundColor: alpha(gray[50], 0.3),
        // '&:hover': {
        //   backgroundColor: gray[100],
        //   borderColor: gray[300],
        // },
        // '&:active': {
        //   backgroundColor: gray[200],
        // },
        // ...theme.applyStyles('dark', {
        //   backgroundColor: gray[800],
        //   borderColor: gray[700],
        //   '&:hover': {
        //     backgroundColor: gray[900],
        //     borderColor: gray[600],
        //   },
        //   '&:active': {
        //     backgroundColor: gray[900],
        //   },
        // }),
        variants: [
          {
            props: {
              size: 'small',
            },
            style: {},
          },
          {
            props: {
              size: 'medium',
            },
            style: {
              width: 40,
              height: 40,
            },
          },
          {
            props: {
              color: 'primary',
            },
            style: {
              backgroundColor: '#ECF1FC',
              color: '#0F60FF',
              '&:hover': {
                backgroundColor: '#11319A',
                color: '#FFFFFF',
              },
            },
          },
          {
            props: {
              color: 'secondary',
            },
            style: {
              backgroundColor: 'transparent',
              color: '#0F60FF',
              '&:hover': {
                backgroundColor: '#ECF1FC',
                color: '#11319A',
              },
            },
          },
        ],
      }),
    },
  },
};
